import { TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';

import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { SideBarWrapperTemplateNode } from 'src/common/models/common/sidebar-wrapper';

import { Sidebar } from 'components/search/sidebar';

export interface SidebarWrapperProps extends TemplateComponentProps {
  templateComponent: SideBarWrapperTemplateNode;
}

export const SidebarWrapper: React.FC<SidebarWrapperProps> = ({ templateComponent }) => {
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();
  const { config } = templateComponent || {};

  return (
    <Viewport>
      <ViewLarge>
        <Sidebar tracker={tracker} viewTracker={viewTracker} withFilters={config?.withFilters} />
      </ViewLarge>
    </Viewport>
  );
};
